export default __webpack_public_path__ + "static/media/26.0323a9b8.png";